/**
 * Given a blob, saves it with the specified fileName.
 * @param blob
 * @param fileName
 */
export function downloadFile(blob: Blob, fileName: string) {
  if (!blob.size) {
    return;
  }
  const downloadLink = document.createElement('a');
  const blobUrl = URL.createObjectURL(blob);
  downloadLink.href = blobUrl;
  downloadLink.download = fileName;
  downloadLink.click();
  URL.revokeObjectURL(blobUrl);
}
